import React, { useState } from 'react';
import ColumnMenuHost from './ColumnMenuHost';
import { NtIcon } from '../NotionUI';
import { useLanguage } from '../../i18n/LanguageContext';

/**
 * Pulsante "⋯" che apre il menu di una colonna (lo stesso della tabella). Si usa accanto ai selettori
 * di colonna delle viste che non hanno intestazioni, come calendario e Gantt.
 */
function ColumnMenuButton({ column, onColumnSubmit, onColumnAction }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const label = t('projectView.columnMenu', { name: column.name });

  return (
    <span className="pd-board-menu">
      <button className="nt-ghost-btn" type="button" aria-label={label} title={label} onClick={() => setOpen(true)}>
        <NtIcon name="more" />
      </button>
      {open && (
        <ColumnMenuHost
          column={column}
          onClose={() => setOpen(false)}
          onColumnSubmit={onColumnSubmit}
          onColumnAction={onColumnAction}
        />
      )}
    </span>
  );
}

export default ColumnMenuButton;
